import hexToRgba from "hex-rgba";

const theme = {
  colors: {
    white: "#fff",
    white8: hexToRgba("#fff", 8),
    white12: hexToRgba("#fff", 12),
    white20: hexToRgba("#fff", 20),
    white30: hexToRgba("#fff", 30),
    white40: hexToRgba("#fff", 40),
    white54: hexToRgba("#fff", 54),
    white70: hexToRgba("#fff", 70),

    black: "#000",
    black4: hexToRgba("#000", 4),
    black8: hexToRgba("#000", 8),
    black12: hexToRgba("#000", 12),
    black20: hexToRgba("#000", 20),
    black30: hexToRgba("#000", 30),
    black38: hexToRgba("#000", 38),
    black54: hexToRgba("#000", 54),
    black70: hexToRgba("#000", 70),
    black87: hexToRgba("#000", 87)
  },
  fonts: {
    text: "system-ui, sans-serif",
    sans: "system-ui, sans-serif"
  },
  breakpoints: { sm: "680px", md: "992px", lg: "1200px" }
};

export default theme;
